import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { type NavAction, type NavItem, type NavItemContext, NavItemTypeEnum } from '@/common/types/navigation'
import i18n from '@/plugins/i18n'

const { t } = i18n.global
export class EvalViewNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    const { gridId, evaluationId } = action.actionData

    yield {
      ...this.getDefaultNavigationItem(action, itemContext),
      text: t('assist.action.evaluation.view'),
      target: `/assist/quality/evaluation/view/${gridId}/${evaluationId}?ticketMode=true`,
      type: NavItemTypeEnum.Link,
    }

    yield {
      ...this.getDefaultNavigationItem(action, itemContext),
      text: t('assist.action.evaluation.edit'),
      target: `/assist/quality/evaluation/edit/${gridId}/${evaluationId}?ticketMode=true`,
      type: NavItemTypeEnum.Link,
    }
  }
}
